import { lazy, type ComponentType } from "react";

const RELOAD_KEY = "__chunk_reloaded_at";

/**
 * React.lazy wrapper that survives stale chunks after a redeploy:
 * retries the dynamic import once, then falls back to a single hard reload.
 */
export function lazyWithRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>
) {
  return lazy(async () => {
    try {
      return await factory();
    } catch (err) {
      // Bust the module cache and try once more.
      try {
        await new Promise((r) => setTimeout(r, 300));
        return await factory();
      } catch {
        const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
        if (Date.now() - last > 10000) {
          sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
          window.location.reload();
          // Keep Suspense pending while the page reloads.
          return await new Promise<{ default: T }>(() => {});
        }
        throw err;
      }
    }
  });
}
